<template>
  <div>
    <template>
      <div class="card border-dark" :key="bill.id">
        <div class="card-body">
          <pr-col class="text-left">
            <h5>
              <b>Nº {{bill.document}}</b>
            </h5>
          </pr-col>
          <pr-col class="text-center">
            <b>Vencimento: {{bill.due_date | dateBr}}</b>
          </pr-col>
          <pr-col class="text-right">
            <p></p>
            <h5>
              <b>R$ {{bill.value | decimal }}</b>
            </h5>
          </pr-col>
          <br />
          <div>
            <div>
              <p>
                No dia
                <b>{{bill.due_date | dateBr}}</b> pagarei(emos) por esta única via de
                <b>
                  NOTA
                  PROMISSÓRIA
                </b> a
                <b>{{company.name}}</b> CPF/CNPJ
                <b>{{company.cnpj}}</b> ou à sua ordem, a quantia de
                <b>{{bill.value | decimal | extenso}}</b> em moeda corrente desse país,
              </p>
            </div>
          </div>
          <div>
            <div
              class="text-left"

            >
              Praça de pagamento:
              <b>{{addressCompany.city}}/{{addressCompany.state}}</b>
            </div>
            <div class="text-right">Emitido em: MANTENA, {{bill .created_at | dateBr}}</div>
          </div>
          <div>
            <div>
              <span>
                Emitente:
                <b>{{person.name}}</b>
              </span>
              <pr-row>CPF/CNPJ: {{person.cpf}}</pr-row>
              <pr-row >
                {{personaddress.address}}, {{personaddress.number}} {{personaddress.complement}} -
                {{ personaddress.district}} - {{personaddress.city}} - {{personaddress.state}} - CEP: {{personaddress.zipcode}}
              </pr-row>
              <br />
            </div>
          </div>
          <hr class="color" width="50%" />
          <p class="text-center">Assinatura do Emitente</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import PrRow from "./../../components/printers/grid/PrRow";
import PrCol from "./../../components/printers/grid/PrCol";
import Filters from "./../../mixins/Filters";

export default {
  components: { PrRow, PrCol },

  props: {
    bill: {},

    company: {},

    addressCompany: {},

    person: {},

    personaddress: {}
  }
};
</script>

<style>
</style>
